import { getArrayCookie, setArrayCookie } from '@shared/cookie';
import { cookieBase } from 'server-data/flconfigs';
import template from 'lodash-es/template';
import { T_ } from '@shared/translation';
import ulTemplate from './templates/searchHistory/ulTemplate.html';

export default class SearchHistory {
  /**
   * searchHistory constructor
   * @param {String}    parentId      The parent ID to attach the search history
   * @param {String}    elementId     An ID to apply to the search history
   * @param {String}    cookieName    The name of the cookie
   * @param {Function}  onClickCallback      The onclick event
   */
  constructor(
    parentId,
    elementId,
    cookieName,
    onClickCallback,
    stackSize = 10,
  ) {
    this.parentId = parentId;
    this.elementId = elementId;
    this.cookieFullPath = `${cookieBase}_${cookieName}`;
    this.cookieExpiry = 30; // 30 days
    this.onClickCallback = onClickCallback;
    this.stackSize = stackSize;
    this._draw();
  }

  /**
   * Replace parent inner HTML with a new search history list
   */
  _draw() {
    // Create the ul template and add it into parent element
    const recentSearchesTemplate = template(ulTemplate)({
      elementId: this.elementId,
    });

    const parentEl = document.getElementById(this.parentId);
    parentEl.innerHTML = recentSearchesTemplate;

    this.ulEl = document.getElementById(this.elementId);

    const recentSearchesArray = this._getList();
    for (let i = 0; i < recentSearchesArray.length; i++) {
      try {
        const keyword = decodeURIComponent(recentSearchesArray[i].keyword);
        const location = recentSearchesArray[i].location;
        let innerText;
        if (recentSearchesArray[i].location.vicinity !== '') {
          innerText = T_`${keyword} in ${location.vicinity}`;
        } else {
          innerText = keyword;
        }
        this._drawLi(i, innerText, keyword, location);
      } catch (e) {
        // no op
      }
    }
  }

  _drawLi(index, innerText, keyword, location) {
    const liEl = document.createElement('li');
    liEl.id = `${this.elementId}-${index}`;
    liEl.className = 'SectionJobFilter-recentSearchesList-item';
    liEl.innerText = innerText;
    // might be a performance issue in <IE11
    liEl.dataset.keyword = keyword;
    liEl.dataset.location = JSON.stringify(location);
    liEl.addEventListener('click', e => this._onElementClick(e));
    // insert to the top of the list
    this.ulEl.insertAdjacentElement('afterbegin', liEl);
    return liEl;
  }

  /**
   * Helper function to find the first occurence of the JSON object in the list
   * @param {array}     arr       The array to find index of
   * @param {Object}    val       The value to be compared
   * @param {Function}  comparer  Compare function
   */
  _indexOf(arr, val, comparer) {
    for (let i = 0, len = arr.length; i < len; ++i) {
      if (i in arr && comparer(arr[i], val)) {
        return i;
      }
    }
    return -1;
  }

  /**
   * Helper function to compare whether 2 JSON object is equal
   * @param {keyword, location} obj1
   * @param {keyword, location} obj2
   */
  _comparer(obj1, obj2) {
    // pesimistic search
    let equal = false;
    if (obj1.keyword === obj2.keyword) {
      equal = true;
    }
    if (
      obj1.location &&
      obj2.location &&
      obj1.location.vicinity === obj2.location.vicinity
    ) {
      equal = equal && true;
    } else {
      equal = false;
    }
    // const isLocationEqual = Object.keys(obj1.location).reduce((acc, key) => {
    //   if (acc) {
    //     acc = obj1.location[key] === obj2.location[key];
    //   }
    //   return acc;
    // }, true);

    // Because we are only showing keyword and location.vicinity on the list,
    // the comparison is only made for those two.
    return equal;
  }

  _onElementClick(e) {
    const data = {
      keyword: decodeURIComponent(e.target.dataset.keyword),
      location: JSON.parse(e.target.dataset.location),
    };
    // push the element to the top of the stack
    this.push(data);
    if (this.onClickCallback) {
      this.onClickCallback(data);
    }
  }
  /**
   * Return search history as an array
   */
  _getList() {
    const cookie = getArrayCookie(this.cookieFullPath);
    return cookie;
  }

  /**
   * Push to the search history stack. If there is duplicate,
   * just move it to the top of the stack
   * @param {keyword, location} newValue
   */
  push(newValue) {
    newValue = {
      keyword: encodeURIComponent(newValue.keyword),
      location: newValue.location,
    };
    const cookie = getArrayCookie(this.cookieFullPath);
    const duplicate = cookie.findIndex(value =>
      this._comparer(value, newValue),
    );
    if (duplicate !== -1) {
      cookie.splice(duplicate, 1);
    }
    cookie.push(newValue);
    if (cookie.length > this.stackSize) {
      cookie.splice(0, 1);
    }
    setArrayCookie(this.cookieFullPath, cookie, this.cookieExpiry);
    this._draw();
  }

  pop() {
    const cookie = getArrayCookie(this.cookieFullPath);
    cookie.pop();
    setArrayCookie(this.cookieFullPath, cookie, this.cookieExpiry);
    this._draw();
  }
}
